<template>
    <div class="cert-header d-flex py-5">
        <div class="col-12 col-md-11 col-lg-10 col-xl-9 px-3 p-md-0 mx-auto">
            <div class="cert-title cert-large">PGP Public Keys</div>
        </div>
    </div>
    <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-9 p-2 p-sm-5 mx-auto mt-2 mt-sm-5 cert-page-content">
        <div ref="i1">
            <cert-law-container title="rwcsirt@ncsa.gov.rw"
                                description="PGP Public Key"
                                url="cyber.gov.rw/index.php?eID=dumpFile&t=f&f=334&token=d58456fa7474467f1ca0833cb16c45b5ea8baa54"
                                :separator="true"/>
        </div>
        <div ref="i2">
            <cert-law-container title="incident@ncsa.gov.rw"
                                description="PGP Public Key"
                                url="cyber.gov.rw/index.php?eID=dumpFile&t=f&f=335&token=511c8f3fdc72246b8c8995dff6718928404bbce9"
                                :separator="false"/>
        </div>
        <div ref="i3">
            <cert-law-container title="vulnerability@ncsa.gov.rw"
                                description="PGP Public Key"
                                url="cyber.gov.rw/index.php?eID=dumpFile&t=f&f=335&token=511c8f3fdc72246b8c8995dff6718928404bbce9"
                                :separator="false"/>
        </div>
    </div>
</template>

<script>
import CertLawContainer from "./components/CertLawContainer"

export default {
    name: "GuideLines",
    components: {
        CertLawContainer
    },
    mounted() {
        this.$anim.fadeInBottomOpaque(this.$refs["content"], 50);
        for (let i = 1; i < 4; i++)
            this.$anim.fadeInBottom(this.$refs[`i${i}`], 50 * i);
    }
}
</script>